import { Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Column } from '../../models'
import { EmployeeService, ViewService } from '../../services'
import { SearchView, User } from '../../interfaces'

@Component({
  selector: 'app-employees',
  templateUrl: './employees.component.html'
})

export class EmployeesComponent extends SearchView<User> {
  public columns: Column [] = [
    this.routerColumn('_id', 'USER.ID', { isPrimary: true }),
    this.routerColumn('name.last', 'USER.LAST_NAME', { isPrimary: true }),
    this.routerColumn('name.first', 'USER.FIRST_NAME', { isPrimary: true }),


    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    new Column('contacts.0', 'USER.CONTACTS', false, null, 'contactCell')
  ]

  constructor (
    viewService: ViewService,
    route: ActivatedRoute,
    service: EmployeeService
  ) {
    super(viewService, route, service, 'employees', 'employee')
    this.params.sort = {
      'name.last': 1,
      'name.first': 1
    }
  }
}
